import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import { compareChips } from '../../utils/comparationFilters';
import { Icon } from '../Icons';
import styles from './style.module.css';

interface ActionProps {
  index: number;
  idCheck?: any;
  onRemove: (index: any, idCheck: any) => void;
  children?: any;
}

export const Chip: FunctionComponent<ActionProps> = ({ children, onRemove, index, idCheck }) => {
  const className = cx(
    'flex items-center br12 bw1 b--abbey b--solid pt4 pl12 pr8 mr12 mb16 mb8-ns f13 normal abbey ttn pointer',
    styles.Chip,
  );
  const handleOnRemove = () => {
    let setIdCheckToString = String(idCheck);
    setIdCheckToString = setIdCheckToString.replace('portas', '');
    setIdCheckToString = setIdCheckToString.replace('marchas', '');
    const normalizeNameId = setIdCheckToString.replace(/\s/g, '');
    if (document.getElementById(normalizeNameId) as HTMLInputElement) {
      (document.getElementById(normalizeNameId) as HTMLInputElement).checked = false;
    }
    onRemove(index, idCheck);
  };

  const buttonClass = cx('pointer bg-transparent bn pa0 pl8 flex', styles.icon);

  return (
    <li className={className} onClick={handleOnRemove}>
      <span className="mb4">{compareChips(children)}</span>
      <button className={buttonClass}>
        <Icon name="SvgIconCloseChip" className="trout" width={8} height={8} />
      </button>
    </li>
  );
};
